var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Stage Title *",
      "label-for": "stage_title"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "stage_title",
      "required": "",
      "placeholder": "Enter stage title"
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.title"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Alias",
      "label-for": "alias"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "alias",
      "value": _vm.slugify(_vm.form.title || ''),
      "placeholder": _vm.form.title ? _vm.slugify(_vm.form.title) : 'Auto generated from title',
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {}, [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Set Running")]), _c('div', [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.is_running,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_running", $$v);
      },
      expression: "form.is_running"
    }
  }, [_vm.form.is_running ? [_vm._v("Yes")] : [_vm._v("No")]], 2)], 1)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {}, [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Set SPAL")]), _c('div', [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.is_spal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_spal", $$v);
      },
      expression: "form.is_spal"
    }
  }, [_vm.form.is_spal ? [_vm._v("Yes")] : [_vm._v("No")]], 2)], 1)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {}, [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Set Denied")]), _c('div', [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.is_deny,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_deny", $$v);
      },
      expression: "form.is_deny"
    }
  }, [_vm.form.is_deny ? [_vm._v("Yes")] : [_vm._v("No")]], 2)], 1)])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {}, [_c('label', {
    staticClass: "mb-0"
  }, [_vm._v("Set Finish")]), _c('div', [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.is_end_stage,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_end_stage", $$v);
      },
      expression: "form.is_end_stage"
    }
  }, [_vm.form.is_end_stage ? [_vm._v("Yes")] : [_vm._v("No")]], 2)], 1)])]), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Description",
      "label-for": "description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "rows": "6",
      "placeholder": "Write description here..."
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }